export { default as Tabs } from './components/Tabs';
export { default as TabList } from './components/TabList';
export { default as Tab } from './components/Tab';
export { default as TabPanel } from './components/TabPanel';
export { reset as resetIdCounter } from './helpers/uuid';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tabs/esm/index.js
// module id = 235
// module chunks = 37